import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';

import {
  ProcessTalentRegistrationFormDto,
  ProcessTalentRegistrationFormDtoType,
  QuestionTranslation
} from '@/api/generated';
import CheckboxGroup from '@/components/fields/CheckboxGroup';
import DropdownSelect from '@/components/fields/DropdownSelect';
import Field from '@/components/fields/Field';
import RadioGroup from '@/components/fields/RadioGroup';
import TextInput from '@/components/fields/TextInput';
import { OTHER_OPTION_ID } from '@/views/TalentRegistrationForm/constants';

// FIXME: delete or uncomment when enum FILE value is clarified what to do with
// import FileUpload from './fields/FileUpload';

const AdditionalInfoQuestion = ({
  talentQuestion,
  translation,
  disabled
  // FIXME: delete or uncomment when enum FILE value is clarified what to do with
  // processId,
  // talentId
}: {
  translation: QuestionTranslation | undefined;
  talentQuestion: ProcessTalentRegistrationFormDto;
  disabled?: boolean;
  processId?: string;
  talentId?: string;
}) => {
  const { t } = useTranslation(['talents', 'settings']);
  const { spacing } = useTheme();
  const { formState } = useFormContext();
  const options = talentQuestion?.optionValues?.map(value => {
    const label = value === OTHER_OPTION_ID ? t('layouts.talentEditModal.other') : translation?.optionLabels?.[value];

    return {
      value,
      label: label ?? ''
    };
  });

  switch (talentQuestion.type) {
    case ProcessTalentRegistrationFormDtoType.TEXT:
      return (
        <Field
          key={talentQuestion?.id}
          withFormControl
          name={talentQuestion?.id}
          component={TextInput}
          innerProps={{
            placeholder: translation?.optionLabels?.placeholder,
            disabled: disabled || formState.isSubmitting
          }}
          label={translation?.label}
          outerSx={{ p: 0, width: '100%', maxWidth: spacing(29) }}
        />
      );
    case ProcessTalentRegistrationFormDtoType.LONG_TEXT:
      return (
        <Field
          key={talentQuestion?.id}
          withFormControl
          name={talentQuestion?.id}
          component={TextInput}
          innerProps={{
            multiline: true,
            minRows: 3,
            placeholder: translation?.optionLabels?.placeholder,
            disabled: disabled || formState.isSubmitting
          }}
          label={translation?.label}
          outerSx={{ p: 0, width: '100%', maxWidth: spacing(29) }}
        />
      );
    case ProcessTalentRegistrationFormDtoType.YEAR:
      return (
        <Field
          key={talentQuestion.id}
          withFormControl
          name={talentQuestion.id}
          component={TextInput}
          label={translation?.label}
          innerProps={{ placeholder: `YYYY`, type: 'number', disabled: disabled || formState.isSubmitting }}
          outerSx={{ p: 0, width: '100%', maxWidth: spacing(29) }}
        />
      );
    case ProcessTalentRegistrationFormDtoType.CHECKBOX:
      return (
        <Field
          withFormControl
          key={talentQuestion.id}
          name={talentQuestion.id}
          label={translation?.label}
          component={CheckboxGroup}
          innerProps={{ options, disabled: disabled || formState.isSubmitting }}
          outerSx={{ p: 0, width: '100%', maxWidth: spacing(29) }}
        />
      );
    case ProcessTalentRegistrationFormDtoType.RADIO:
      return (
        <Field
          withFormControl
          key={talentQuestion.id}
          name={talentQuestion.id}
          label={translation?.label}
          component={RadioGroup}
          innerProps={{ options, disabled: disabled || formState.isSubmitting }}
          outerSx={{ p: 0, width: '100%', maxWidth: spacing(29) }}
        />
      );
    case ProcessTalentRegistrationFormDtoType.SELECT:
      return (
        <Field
          withFormControl
          key={talentQuestion.id}
          name={talentQuestion.id}
          label={translation?.label}
          component={DropdownSelect}
          innerProps={{ options, isMulti: true, isDisabled: disabled || formState.isSubmitting }}
          outerSx={{ p: 0, width: '100%', maxWidth: spacing(29) }}
        />
      );
    // FIXME: delete or uncomment when enum FILE value is clarified what to do with
    // case ProcessTalentRegistrationFormDtoType.FILE:
    //   return (
    //     <Field
    //       withFormControl
    //       key={talentQuestion.id}
    //       name={talentQuestion.id}
    //       label={translation?.label || t('settings:orgSettings.talentRegistrationForm.questionType.file')}
    //       component={FileUpload}
    //       innerProps={{ processId, talentId, disabled: disabled || formState.isSubmitting }}
    //       outerSx={{ p: 0, width: '100%', maxWidth: spacing(29) }}
    //     />
    //   );
  }
};
export default AdditionalInfoQuestion;
